import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import CardholderProfileForm from './CardholderProfileForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import WizardCard from 'react/signups/card/common/WizardCard';
import addressShape from 'react/signups/card/shapes/AddressShape';
import cardholderProfileShape from 'react/signups/card/shapes/CardholderProfile';

export default function CardholderProfile({
  cardholderProfileData,
  firstName,
  moduleComplete,
  organizationAddress,
  setCardholderProfileData,
}) {
  const validationSchema = Yup.object().shape({
    address: Yup.object().when('sameAddress', {
      is: 'false',
      then: () => schema.address.required(),
    }),
    dateOfBirth: schema.dateOfBirth.required(),
    mobile: schema.mobile,
    countryOfCitizenship: schema.countryOfCitizenship.required(),
    nonResidentAlien: Yup.string().when(['countryOfCitizenship'], {
      is: (countryOfCitizenship) => countryOfCitizenship !== 'US',
      then: () => schema.nonResidentAlien.required(),
      otherwise: () => schema.nonResidentAlien.nullable(),
    }),
  });

  const handleContinue = (values) => {
    const same = values.sameAddress === 'true';
    setCardholderProfileData({
      sameAddress: values.sameAddress,
      address: {
        street1: same ? organizationAddress.street1 : values.address.street1,
        street2: same ? organizationAddress.street2 : values.address.street2,
        city: same ? organizationAddress.city : values.address.city,
        state: same ? organizationAddress.state : values.address.state,
        zip: same ? organizationAddress.zip : values.address.zip,
      },
      dateOfBirth: values.dateOfBirth,
      mobile: values.mobile,
      countryOfCitizenship: values.countryOfCitizenship || '',
      nonResidentAlien: values.nonResidentAlien || '',
    });
  };

  return (
    <WizardCard>
      <CardHeader>Tell us about {firstName}</CardHeader>
      <Formik
        initialValues={cardholderProfileData}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, setFieldTouched, setValues, values }) => (
          <>
            <CardholderProfileForm
              firstName={firstName}
              onChange={handleChange}
              organizationAddress={organizationAddress}
              setFieldTouched={setFieldTouched}
              setValues={setValues}
              values={values}
            />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

CardholderProfile.propTypes = {
  cardholderProfileData: cardholderProfileShape.isRequired,
  firstName: PropTypes.string.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  organizationAddress: addressShape.isRequired,
  setCardholderProfileData: PropTypes.func.isRequired,
};
